import { inject, type InjectionKey, type Ref } from 'vue'

import type { BrandColorField } from '../lib/brandColorValidation'
import type { OnboardingFormData } from '../lib/onboardingPrefill'

export type OnboardingDataEntryContext = {
  formData: Ref<OnboardingFormData>
  aiCapturedFields: Ref<Set<string>>
  updateField: (field: string, value: string | boolean) => void
  onFieldFocus: (key: string) => void
  fieldClass: (key: string) => string
  isUsOnboarding: Ref<boolean>
  hasNoWebsite: Ref<boolean>
  /** Inline required/format error, only once the field was visited or continue was attempted. */
  visibleFieldError: (key: string) => string
  markFieldTouched: (key: string) => void
  isFieldRequired: (key: string) => boolean
  /** ISO country preselected in phone fields (`US` → +1). */
  defaultPhoneCountry: Ref<string | null>
  /** Typed brand colors that failed validation and are not stored yet. Null when there is none. */
  brandColorDrafts: Record<BrandColorField, string | null>
}

export const onboardingDataEntryKey: InjectionKey<OnboardingDataEntryContext> =
  Symbol('onboardingDataEntry')

export function useOnboardingDataEntryContext(): OnboardingDataEntryContext {
  const ctx = inject(onboardingDataEntryKey)
  if (!ctx) {
    throw new Error('useOnboardingDataEntryContext() must be used inside OnboardingDataEntry')
  }
  return ctx
}
